import { render, staticRenderFns } from "./thirdScenario.vue?vue&type=template&id=297cc42a"
import script from "./thirdScenario.vue?vue&type=script&lang=js"
export * from "./thirdScenario.vue?vue&type=script&lang=js"
import style0 from "./thirdScenario.vue?vue&type=style&index=0&id=297cc42a&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('297cc42a')) {
      api.createRecord('297cc42a', component.options)
    } else {
      api.reload('297cc42a', component.options)
    }
    module.hot.accept("./thirdScenario.vue?vue&type=template&id=297cc42a", function () {
      api.rerender('297cc42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/third/thirdScenario.vue"
export default component.exports